import { FC } from 'react';
import { connect, EasyField } from 'react-bootstrap-formutil';
import { CustomerInfoKeyType, HomeAddressTypeEnum } from 'types/customer';
import { BaseHomeAddressProps } from '../type';
import BaseAddress from './BaseAddress';

export interface Common2HomeAddressProps extends Omit<BaseHomeAddressProps, 'prefix'> {
    hasCountry?: boolean;
    hideMailAddress?: boolean;
    legalResidenceCountry?: string;
}

export const getCommon2HomeAddressFields = (needHomeAddressType: boolean = true) => {
    const baseFields: CustomerInfoKeyType[] = [
        'home_detail',
        'home_detail2',
        'home_city',
        'home_postal',
        'home_state_code',
        'same_delivery_and_residence'
    ];

    return needHomeAddressType ? baseFields.concat('home_address_type') : baseFields;
};

/**
 * @description COMMON2居住地址格式表单组件，目前仅非SSN加拿大使用
 */
const Common2HomeAddress: FC<Common2HomeAddressProps> = ({ hasCountry, legalResidenceCountry, ...restProps }) => {
    return (
        <>
            <BaseAddress prefix="home" legalResidenceCountry={legalResidenceCountry} {...restProps} />
            {hasCountry && <EasyField type="hidden" name="home_country" $defaultValue={legalResidenceCountry} />}
            <EasyField name="home_address_type" type="hidden" $defaultValue={HomeAddressTypeEnum.COMMON2} />
        </>
    );
};

export default connect(Common2HomeAddress);
